import { createContext } from 'react';

export interface SidebarContextValue {
  isOpen: boolean;
  onClose?: () => void;
  id: number | string;
}

export const SidebarContext = createContext<SidebarContextValue>({
  isOpen: false,
  id: 'NO-ID',
});
